<script lang="ts">
	import { findPropsByApiKey } from '@app/utils/kyc';
	import InputTel from '$lib/elements/inputs/variants/InputTel.svelte';
	import { page } from '$app/stores';
	import type { InputSelectProps } from '$lib/elements/inputs/types';
	export let props;
	let phoneProps;
	let phoneCodesProps;

	let phoneCodes: InputSelectProps = {
		value: $page.data?.user?.coordinates?.phoneCode || 'FRA',
		required: true
	};
	$: phoneProps = findPropsByApiKey(props.questions, 'telephoneMobile');

	$: {
		if (phoneCodes?.value) {
			phoneCodesProps = findPropsByApiKey(props.questions, 'indicatifTelMobile');
			phoneCodesProps.value = phoneCodes?.value;
		}
	}
</script>

<InputTel bind:props={phoneProps} bind:phoneCodesProps={phoneCodes} withCode={true} />
